import { Menu } from "grommet";
import { Language } from "grommet-icons";
import { startTransition } from "react";
import { useTranslation } from "react-i18next";

export const LanguageSelector = () => {
    const {i18n} = useTranslation();

    const setLanguage = (lang) => {
        localStorage.setItem('i18nextLng', lang);
        startTransition(() => {
            i18n.changeLanguage(lang);
        });
    }

    const langs = [
        { 
            label: '🇺🇦 Українська',
            onClick: () => setLanguage('uk')
        },
        { 
            label: '🇬🇧 English',
            onClick: () => setLanguage('en')
        }
    ];
    return (
        <Menu icon={<Language/>} items={langs}/>
    )
}
